import { StackProps } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { SketchPicker } from 'react-color';

import {
  Box,
  HStack,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  SimpleGrid,
  Text,
  VStack,
} from '../../../core-ui';
import { Icon } from '../../uiold';

const ColorList = [
  '#b60205',
  '#d93f0b',
  '#fbca04',
  '#0e8a16',
  '#006b75',
  '#1d76db',
  '#0052cc',
  '#5319e7',
  '#e99695',
  '#f9d0c4',
  '#ffa436',
] as const;

export const DEFAULT_TAG_COLOR = ColorList[0];

type Props = Omit<StackProps, 'children'> & {
  isOpen: boolean;
  selectedColor: string;
  onColorSelect: (color: string) => void;
  /** When the user clicks a fixed color we call this to indicate that we're done */
  onDone: () => void;
};

export function ColorPalette(props: Props) {
  const { isOpen, selectedColor, onColorSelect, onDone, ...otherProps } = props;
  const [isFullPaletteOpen, setFullPaletteOpen] = useState(false);
  // Close the full palette when this one closes
  useEffect(() => {
    if (!isOpen) {
      setFullPaletteOpen(false);
    }
  }, [isOpen]);

  return (
    <VStack align="stretch" {...otherProps}>
      <Text>{t('Select Color:')}</Text>
      <HStack>
        <SimpleGrid columns={4} gap={2}>
          {ColorList.map((color, i) => (
            <IconButton
              key={i}
              variant="unstyled"
              aria-label={t('Hex Color {color}', { color })}
              w={6}
              h={6}
              minW={0}
              onClick={() => {
                onColorSelect(color);
                onDone();
              }}
              icon={
                <Box w={6} h={6} borderRadius="full" backgroundColor={color} />
              }
            />
          ))}
          <Popover
            autoFocus={false}
            isOpen={isFullPaletteOpen}
            onClose={() => {
              setFullPaletteOpen(false);
            }}
          >
            <PopoverTrigger>
              <IconButton
                aria-label={t('Pick color')}
                backgroundColor="white"
                borderRadius={20}
                icon={<Icon name="plusCircle" size={24} color="#0A2841" />}
                onClick={() => setFullPaletteOpen((isOpen) => !isOpen)}
                size="xs"
              />
            </PopoverTrigger>
            <PopoverContent width="246px">
              <PopoverArrow />
              <PopoverBody>
                <SketchPicker
                  color={selectedColor}
                  disableAlpha
                  onChange={(color) => {
                    onColorSelect(color.hex);
                  }}
                  presetColors={[]}
                />
              </PopoverBody>
            </PopoverContent>
          </Popover>
        </SimpleGrid>
      </HStack>
    </VStack>
  );
}
